export function initMenu() {

	///////////////////////////// MMENU /////////////////////////////////

	$("#my-menu").mmenu({
		 extensions: [
				"theme-dark"
		 ],
		 navbar: {"title": "TNT"}
	},{
		 offCanvas: {
				pageSelector: "main"
		 }
	});

	var $icon = $("#hamburger-menu");
	var API = $("#my-menu").data( "mmenu" );

	$icon.on( "click", function() {
		 API.open();
	});

	// add class to icon when menu is opened/closed
	// API bind is not a functional on mmenu 8.5.24, so using jQuery events
	$("#my-menu")
		.on( "opened.mm", function() {
			$icon.addClass( "is-active" );
		})
		.on( "closed.mm", function() {
			$icon.removeClass( "is-active" );
		});
	

}
